import React, { Component } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import AwsConfig from '../../Config/AwsConfig'
import ListAssociationFeaturedTournaments from '../../Services/Queries/ListAssociationFeaturedTournaments'
import ListAssociations from '../../Services/Queries/ListAssociations'
import ImageOptions from './ImageOptions'
import ImageUpload from './ImageUpload'
import { DefinedPermissions } from '../Constants/Permissions'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import CompressContentImage from '../../Services/Mutations/compressContentImage'
import { MatchData } from '../Data/StaticData'
import { Auth } from 'aws-amplify'

export default class PointsTable extends Component {
  imageTemplateTypes = []
  constructor(props) {
    super(props)
    this.state = {
      cricketPointsTableTitle: '',
      cricketPointsTableDescription: '',
      chooseFeaturedMatchModalVisible: false,
      teamsList: [],
      selectedFeaturedMatch: '',
      featuredMatches: [],
      selectedIcons: [],
      selectedIconsObjArr: [],
      chooseAssociationModalVisible: false,
      chooseTournamentModalVisible: false,
      selectedTypes: [],
      cricketPointsTableImages: [],
      associationsList: [],
      selectedAssociation: {},
      associationTournamentsList: [],
      selectedTournament: {},
      loggedInUserPermissions: [],
      matchInfo: MatchData
    }
    // this.presser = this.presser.bind(this)
  }
  hastitleError = () => {
    return !this.state.cricketPointsTableTitle != ''
  }
  handleTitle = (e) => {
    const title = e.target.value
    this.setState({ cricketPointsTableTitle: title })
    this.props.updateInParent(
      `cricketPointsTableTitle_${this.props.contentSelectedLangVal}`,
      title,
      'cricketPointsTable'
    )
  }
  updateData = async () => {
    const {
      editContent,
      cricketPointsTableDetails,
      contentSelectedLangVal,
      associationKey,
      tournamentKey,
    } = this.props
    if (cricketPointsTableDetails) {
      const selectedAssociationIndex = this.state.associationsList.findIndex((item, index) => {
        return item.key == associationKey
      })
      const selectedAssociation = this.state.associationsList[selectedAssociationIndex]
      const input = { associationKey: selectedAssociation ? selectedAssociation.key : '' }
      let selectedTournament = {}
      const listAssociationsPermission = this.state.loggedInUserPermissions.includes(
        DefinedPermissions['listAssociationsPermission']
      )
      let associationTournamentsResponse = []
      if (listAssociationsPermission) {
        associationTournamentsResponse = await ListAssociationFeaturedTournaments(input)
      }
      console.log(associationTournamentsResponse, 'associationTournamentsResponse')
      if (associationTournamentsResponse.tournamentsInfo) {
        associationTournamentsResponse = JSON.parse(associationTournamentsResponse.tournamentsInfo)
        console.log(associationTournamentsResponse, 'associationTournamentsResponse=============')
        const selectedTournamentIndex = associationTournamentsResponse.findIndex((item, index) => {
          return item.key == this.props.tournamentKey
        })
        selectedTournament = associationTournamentsResponse[selectedTournamentIndex]
      }
      this.setState({
        cricketPointsTableTitle:
          cricketPointsTableDetails[`cricketPointsTableTitle_${contentSelectedLangVal}`],
        cricketPointsTableDescription:
          cricketPointsTableDetails[`cricketPointsTableDescription_${contentSelectedLangVal}`],
        cricketPointsTableImages:
          cricketPointsTableDetails && cricketPointsTableDetails.cricketPointsTableImages
            ? cricketPointsTableDetails.cricketPointsTableImages
            : [],
        selectedAssociation: selectedAssociation,
        selectedTournament: selectedTournament,
      })
    }
  }
  componentDidMount = async () => {
    let associationsResponse = []
    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    console.log(permissionInput, 'permissionInput')
    const userPermissions = await GetUserPermissions(permissionInput)
    console.log(userPermissions, 'userPermissions')
    let permissions = []
    let permissionsArr = []
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map((item) => {
        permissions.push(...item.permissions)
      })
      permissions.map((permission) => {
        permissionsArr.push(permission.name)
      })
    }
    console.log(permissionsArr, 'permissionsArr')
    const listAssociationsPermission = permissionsArr.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    // if (listAssociationsPermission) {
    //   associationsResponse = await ListAssociations()
    //   console.log(associationsResponse, 'associationsResponse')

    //   if (associationsResponse.associationsInfo) {
    //     associationsResponse = JSON.parse(associationsResponse.associationsInfo)
    //     console.log(associationsResponse, 'associationsResponse=============')
    //     this.setState({
    //       associationsList: associationsResponse,
    //     })
    //   }
    // }
    this.setState({
      loggedInUserPermissions: permissionsArr,
    })
    if (this.props.editContent) {
      await this.updateData()
    }
  }

  listAssociationsService = async () => {
    const { loggedInUserPermissions } = this.state
    const listAssociationsPermission = loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    let associationsResponse = []
    if (listAssociationsPermission) {
      associationsResponse = await ListAssociations()
      console.log(associationsResponse, 'associationsResponse')

      if (associationsResponse.associationsInfo) {
        associationsResponse = JSON.parse(associationsResponse.associationsInfo)
        console.log(associationsResponse, 'associationsResponse=============')
      }
    }
    this.setState({
      associationsList: associationsResponse,
      chooseAssociationModalVisible: true
    })
    if (this.props.editContent) {
      await this.updateData()
    }
  }

  componentDidUpdate = async (prevProps) => {
    if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
      if (this.props.editContent) {
        await this.updateData()
      }
    }
  }
  handlecricketPointsTableImages = (images) => {
    const imagesArr = []
    images.filter((item) => {
      const obj = {
        image: item.key ? item.key : item.image,
        copyRight: item.copyRight,
        copyRightText: item.copyRightText,
        shareImage: item.shareImage,
      }
      imagesArr.push(obj)
    })
    this.props.updateInParent('cricketPointsTableImages', imagesArr, 'cricketPointsTable')
    this.setState({ cricketPointsTableImages: images })
  }
  pushImageObj = async (imageObj) => {
    const { cricketPointsTableImages } = this.state
    cricketPointsTableImages.push(imageObj)
    const input = {
      imagePath: imageObj.key
    }
    console.log(input, "===========compressImageinput")

    if (input != undefined && input != null && input.imagePath != null && input.imagePath != undefined && input.imagePath != "") {
      const response = await CompressContentImage(input)
      console.log(response, "response compress image ==========")
    }
    this.handlecricketPointsTableImages(cricketPointsTableImages)
  }

  removeImage = (imageIndex) => {
    const images = this.state.cricketPointsTableImages
    images.splice(imageIndex, 1)
    this.handlecricketPointsTableImages(images)
  }

  selectAssociation = (association) => {
    this.setState({ selectedAssociation: association, selectedTournament: {} })
    this.selectTournament({})
    this.props.handleSelectedAssociation(association.key)
    this.props.updateInParent('associationKey', association.key, 'cricketPointsTable')
  }
  selectTournament = (tournament) => {
    this.setState({ selectedTournament: tournament })
    const tournamentKey = tournament && tournament.key ? tournament.key : ''
    this.props.handleSelectedTournament(tournamentKey)
    this.props.updateInParent('tournamentKey', tournamentKey, 'cricketPointsTable')
  }

  openTournamentsListModal = async () => {
    const input = { associationKey: this.state.selectedAssociation.key }
    // console.log(input, 'inputtt')
    let associationTournamentsResponse = await ListAssociationFeaturedTournaments(input)
    // console.log(associationTournamentsResponse, 'associationTournamentsResponse')
    if (associationTournamentsResponse.tournamentsInfo) {
      associationTournamentsResponse = JSON.parse(associationTournamentsResponse.tournamentsInfo)
      // console.log(associationTournamentsResponse, 'associationTournamentsResponse=============')
      this.setState({ associationTournamentsList: associationTournamentsResponse })
    }
    this.setState({ chooseTournamentModalVisible: true })
  }
  renderAssociationsListModal = () => {
    const cdnurl = AwsConfig.cdn_url

    return (
      <Modal
        show={this.state.chooseAssociationModalVisible}
        onHide={() => this.setState({ chooseAssociationModalVisible: false })}
      >
        <Modal.Body>
          <div className='associationsList'>
            {this.state.associationsList.map((association, associationIndex) => {
              const bgColor =
                this.state.selectedAssociation &&
                  this.state.selectedAssociation.name != '' &&
                  this.state.selectedAssociation.name == association.name
                  ? '#e6e6e6'
                  : ''
              return (
                <div
                  class='card p-3 teamCard'
                  style={{ backgroundColor: bgColor }}
                  onClick={() => this.selectAssociation(association)}
                >
                  <text className='mt-2' style={{ fontSize: 10 }}>
                    {association.name}
                  </text>
                </div>
              )
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.setState({ chooseAssociationModalVisible: false })}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderTournamentsListModal = () => {
    const cdnurl = AwsConfig.cdn_url

    return (
      <Modal
        show={this.state.chooseTournamentModalVisible}
        onHide={() => this.setState({ chooseTournamentModalVisible: false })}
      >
        <Modal.Body>
          <div className='associationsList'>
            {this.state.associationTournamentsList.map((tournament, tournamentIndex) => {
              const bgColor =
                this.state.selectedTournament &&
                  this.state.selectedTournament.name != '' &&
                  this.state.selectedTournament.name == tournament.name
                  ? '#e6e6e6'
                  : ''
              return (
                <div
                  class='card p-3 teamCard'
                  style={{ backgroundColor: bgColor }}
                  onClick={() => this.selectTournament(tournament)}
                >
                  <text className='mt-2' style={{ fontSize: 10 }}>
                    {tournament.name}
                  </text>
                </div>
              )
            })}
            {this.state.associationTournamentsList.length == 0 ? (
              <text>No Tournaments Available...Choose Other Association...</text>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.setState({ chooseTournamentModalVisible: false })}>Ok</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  render() {
    const { data } = this.props
    const cdnurl = AwsConfig.cdn_url

    const { cricketPointsTableTitle, cricketPointsTableDescription } = this.state
    // console.log(this.state.selectedFeaturedMatch, 'selectedFeaturedMatch')
    let selectedFeaturedMatchName = ''
    if (this.state.featuredMatches[this.state.selectedFeaturedMatch]) {
      selectedFeaturedMatchName = this.state.featuredMatches[this.state.selectedFeaturedMatch].name
    }
    const listAssociationsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    const listAssociationFeaturedMatchesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationFeaturedMatchesPermission']
    )
    return (
      <div class='row col-md-10'>
        {/* <GeneralOptions data={this.state} handleChangeLanguage={this.handleChangeLanguage} /> */}
        <details>
          <summary>Points Table Details</summary>
          <div class='content'>
            {this.renderAssociationsListModal()}
            {this.renderTournamentsListModal()}
            <div class='row'>
              <text for='text'>Title :</text>
              <textarea
                type='text'
                onChange={(value) => {
                  this.handleTitle(value)
                }}
                value={cricketPointsTableTitle}
                placeholder='Please Enter  Title'
              ></textarea>
              {this.hastitleError() ? (
                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                  Title Cannot Be Empty
                </text>
              ) : null}
            </div>
            {listAssociationsPermission ? (
              <div>
                <div class='form-group'>
                  <label for='selectedAssociation'>Choose Association</label>
                  <input
                    disabled={this.props.editContent ? true : false}
                    type='select'
                    value={
                      this.state.selectedAssociation && this.state.selectedAssociation.name
                        ? this.state.selectedAssociation.name
                        : ''
                    }
                    class='form-control'
                    id='selectedAssociation'
                    placeholder='Choose Association'
                    // onClick={() => this.setState({ chooseAssociationModalVisible: true })}
                    onClick={() => this.listAssociationsService()}
                  />
                </div>
                {!this.state.selectedAssociation.name ? (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Please choose an association
                  </text>
                ) : null}
              </div>
            ) : (
              <div>
                <p class='card-subtitle text-muted cardSubTitle'>
                  {'Selected Association'} :{' '}
                  {this.state.selectedAssociation && this.state.selectedAssociation.name
                    ? this.state.selectedAssociation.name
                    : this.props.associationKey}
                </p>
              </div>
            )}

            <div className='associationslist'>
              {this.state.matchInfo.map((match, index) => {
                const bgColor =
                  this.state.selectedAssociation &&
                    this.state.selectedAssociation.name != '' &&
                    this.state.selectedAssociation.name == match.name
                    ? '#e6e6e6'
                    : ''
                return (
                  <div
                    class='card p-3 teamCard'
                    style={{ backgroundColor: bgColor }}
                    onClick={() => this.selectAssociation(match)}
                  >
                    <text className='mt-2' style={{ fontSize: 10 }}>
                      {match.name}
                    </text>
                  </div>
                )
              })}
            </div>
            {listAssociationFeaturedMatchesPermission ? (
              // && this.state.selectedAssociation &&
              //   this.state.selectedAssociation.name ? (
              <div>
                <div class='form-group'>
                  <label for='selectedTournament'>Choose Tournament</label>
                  <input
                    disabled={this.props.editContent ? true : false}
                    type='select'
                    value={
                      this.state.selectedTournament && this.state.selectedTournament.name
                        ? this.state.selectedTournament.name
                        : ''
                    }
                    class='form-control'
                    id='selectedTournament'
                    placeholder='Choose Tournament'
                    onClick={() => this.openTournamentsListModal()}
                  />
                </div>
                {!this.state.selectedTournament.name ? (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Please choose a tournament
                  </text>
                ) : null}
              </div>
            ) : (
              <div>
                <p class='card-subtitle text-muted cardSubTitle'>
                  {'Selected Tournament'} :{' '}
                  {this.state.selectedTournament && this.state.selectedTournament.name
                    ? this.state.selectedTournament.name
                    : this.props.tournamentKey}
                </p>
              </div>
            )}
            <div class='row'>
              <text for='text'>Thumbnail Image :</text>
              <div className='App'>
                <ImageUpload
                  pushImageObj={this.pushImageObj}
                  multiImages={false}
                  circularCrop={false}
                />
                {this.state.cricketPointsTableImages.length > 0 ? null : (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Please upload an image
                  </text>
                )}
                {this.state.cricketPointsTableImages?.map((item, index) => {
                  const { copyRightText, copyRight, shareImage, key, imageValue, image } = item
                  const cdnurl = AwsConfig.cdn_url
                  let finalImage = image ? image : ''
                  if (finalImage && !finalImage.includes(cdnurl)) {
                    finalImage = cdnurl + image
                  }

                  const srcImg = image ? finalImage : imageValue
                  return (
                    <div className='imagesContainer'>
                      <img style={{ maxWidth: '100%' }} src={srcImg} />
                      <button onClick={() => this.removeImage(index)}>Remove Image</button>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </details>
      </div>
    )
  }
}
